export function getTheme() {
  return localStorage.getItem("shd-theme") || "light";
}

export function applyTheme(theme) {
  document.documentElement.classList.toggle("dark", theme === "dark");
  localStorage.setItem("shd-theme", theme);
  window.dispatchEvent(new Event("shd-theme"));
}

export function initTheme() {
  document.documentElement.classList.toggle("dark", getTheme() === "dark");
}
